import { Link } from 'react-router-dom';
import { companyInfo } from '@/mocks/company';

export default function Footer() {
  const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

  const maquinaLinks = [
    { to: '/maquina-de-solda-de-geomembrana', label: 'O que é' },
    { to: '/maquina-de-solda-geomembrana-automatica', label: 'Automática' },
    { to: '/maquina-de-solda-geomembrana-manual', label: 'Manual' },
    { to: '/maquina-de-solda-pead', label: 'PEAD' },
    { to: '/modelos-de-maquinas', label: 'Comparativo' },
  ];

  const infoLinks = [
    { to: '/maquina-de-solda-de-geomembrana-preco', label: 'Preço' },
    { to: '/comprar-maquina-de-solda-de-geomembrana', label: 'Comprar' },
    { to: '/contato', label: 'Orçamento' },
    { to: '/faq', label: 'FAQ' },
    { to: '/sobre', label: 'Sobre' },
  ];

  return (
    <footer className="bg-foreground-950 text-white" id="contato">
      <div className="w-full px-4 md:px-6 lg:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="flex items-center">
                <span className="font-heading text-xl font-bold tracking-wide uppercase text-white">
                  Máquina de Solda
                </span>
                <span className="font-heading text-xl font-bold tracking-wide uppercase text-primary-400 ml-1">
                  Geomembrana
                </span>
              </span>
              <span className="block mt-1.5 text-xs font-medium tracking-wide text-foreground-400">
                DA EMPRESA SOLDAGEO IMPORTACOES
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-sm">
              Especialista em máquinas de solda para geomembrana. Distribuidor oficial no Brasil
              com suporte técnico especializado e peças originais.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href={companyInfo.facebook}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:border-primary-500 hover:text-primary-400 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href={companyInfo.instagram}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:border-primary-500 hover:text-primary-400 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:border-primary-500 hover:text-primary-400 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h6 className="text-xs font-bold uppercase tracking-widest text-primary-400 mb-4">
              Máquinas
            </h6>
            <ul className="space-y-2">
              {maquinaLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h6 className="text-xs font-bold uppercase tracking-widest text-primary-400 mb-4">
              Informações
            </h6>
            <ul className="space-y-2">
              {infoLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h6 className="text-xs font-bold uppercase tracking-widest text-primary-400 mb-4">
              Contato
            </h6>
            <div className="flex flex-col gap-3">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-2 text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-primary-500"></i>
                {companyInfo.phone}
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2 text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-primary-500"></i>
                {companyInfo.email}
              </a>
              <div className="flex items-start gap-2 text-foreground-400 text-sm">
                <i className="ri-map-pin-line mt-0.5 flex-shrink-0 text-primary-500"></i>
                <span className="leading-relaxed">
                  {companyInfo.address}
                  <br />
                  {companyInfo.city} — {companyInfo.state}
                </span>
              </div>
            </div>
            <div className="mt-5 p-3 bg-foreground-900 rounded-xl border border-foreground-800">
              <p className="text-foreground-500 text-xs mb-0.5">CNPJ</p>
              <p className="text-foreground-300 text-sm font-mono">{companyInfo.cnpj}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
          <p className="text-foreground-600 text-xs">
            © {new Date().getFullYear()} {companyInfo.name}. Todos os direitos reservados.
          </p>
          <p className="text-foreground-700 text-xs">
            Máquinas de solda geomembrana — Brasil
          </p>
        </div>
      </div>
    </footer>
  );
}